import { AppliesToDraftResultDao, ConsiderationTypeDao, HomeEvalResultDao } from '@rock/db-admin';
import type { ConsiderationType, ConsiderationTypeId, SpaceId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const considerationTypeDao = new ConsiderationTypeDao();
const homeEvalResultDao = new HomeEvalResultDao();
const appliesToDraftResultDao = new AppliesToDraftResultDao();

export const considerationTypesState = considerationTypeDao.considerationTypesAtom();

export const considerationTypeState = atomFamily(
    (typeId: ConsiderationTypeId | undefined) => considerationTypeDao.considerationTypeAtom(typeId),
    shallowEqual,
);

export const considerationTypesForSpaceState = atomFamily(
    (spaceId: SpaceId) => considerationTypeDao.considerationTypesForSpaceAtom(spaceId),
    shallowEqual,
);

export const considerationTypesByIdState = atomFamily(
    (spaceId: SpaceId) =>
        atom(async (get) => {
            const types = await get(considerationTypesForSpaceState(spaceId));
            const acc: Record<ConsiderationTypeId, ConsiderationType> = {};
            for (const t of types) {
                acc[t.id] = t;
            }
            return acc;
        }),
    shallowEqual,
);

export const homeEvalResultsState = atomFamily(
    (typeId: ConsiderationTypeId | undefined) => homeEvalResultDao.homeEvalResultsForConsiderationTypeAtom(typeId),
    shallowEqual,
);

export const appliesToDraftResultsState = atomFamily(
    (typeId: ConsiderationTypeId | undefined) =>
        appliesToDraftResultDao.appliesToDraftResultsForConsiderationTypeAtom(typeId),
    shallowEqual,
);
